import { IColumnConfigTableResponsive } from "src/app/domain/IColumnConfigTableResponsive";
import { FieldTypeEnum } from "src/app/domain/registration/enums/field-type.enum";
import { TypeComponentFieldEnum } from "src/app/domain/registration/enums/type-component-dynamic.enum";
import { IFieldConfig } from '../../../../../domain/IFieldConfig';

export const COLUMNS_TO_SHOW_WEB = [
    'select',
    'value',
    'type',
    'status',
    'description',
    'payerName',
    'createdAt',
    'dischargeDate',
    'actions'
];

export const COLUMNS_TO_SHOW_MOBILE = [
    'select',
    'value',
    'type',
    'status',
    'description',
    'actions'
];

export const TABLE_CONFIG_COLUMNS: IColumnConfigTableResponsive[] = [
    {
        property: 'value',
        field_type: FieldTypeEnum.LABEL,
        display: 'Valor',
        class: 'text-left',
        maxLength: 20
    },
    {
        property: 'type',
        field_type: FieldTypeEnum.LABEL,
        display: 'Tipo',
        class: 'text-left',
        maxLength: 20
    },
    {
        property: 'status',
        field_type: FieldTypeEnum.LABEL,
        display: 'Status',
        class: 'text-left',
        maxLength: 20
    },
    {
        property: 'description',
        field_type: FieldTypeEnum.LABEL,
        display: 'Descrição',
        class: 'text-left',
        maxLength: 20
    },
    {
        property: 'payerName',
        field_type: FieldTypeEnum.LABEL,
        display: 'Pagador',
        class: 'text-left',
        maxLength: 15
    },
    {
        property: 'createdAt',
        field_type: FieldTypeEnum.LABEL_DATE,
        display: 'Data Criação',
        class: 'text-left',
        maxLength: 15
    },
    {
        property: 'dischargeDate',
        field_type: FieldTypeEnum.LABEL_DATE,
        display: 'Data de Baixa',
        class: 'text-left',
        maxLength: 15
    },


];

export const FILTER_CONFIG_FIELDS: IFieldConfig[] = [
    {
        type: TypeComponentFieldEnum.SELECT,
        name: 'tipoDataPesquisa',
        label: 'Tipo de Data',
        options: [
            { value: 0, label: 'Criação' },
            { value: 1, label: 'Baixa' }
        ],
        display: 'label'
    },
    {
        type: TypeComponentFieldEnum.INPUT_DATE,
        label: 'Data Inicio',
        name: 'startDate',
        placeholder: 'Selecione a data de início',
    },
    {
        type: TypeComponentFieldEnum.INPUT_DATE,
        label: 'Data Fim',
        name: 'endDate',
        placeholder: 'Selecione a data de fim',
    },
];
